<template>
    <div class="container">
        <vue-daum-postcode @complete="setResult($event)"/>
    </div>
</template>
<script>
    import {VueDaumPostcode} from "vue-daum-postcode"

    export default {
        name: 'Postcode',
        components: {
            VueDaumPostcode,
        },
        data() {
            return {
                result : ''
            }
        },
        methods: {
            setResult(event) {
                this.result = event;
                //this.$emit( 'before-close', this.result.address)
                console.log(this.result);
                this.apply()
            },
            apply() {
                this.$emit('before-close', this.result.address)
                this.close();
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>
<style scoped>
    .info-window-container {
        padding: 10px;
        width: 300px;
        height: 100px;
    }
</style>
